import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class ViewApplicationDetailsTpamsConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static FILE_NUMBER_LABEL = "File number";
    static AMENDMENT_SCHEME_NUMBER_LABEL = "Amendment scheme number";
    static PREVIOUS_REFERENCE_NUMBER_LABEL = "Previous reference number";
    static IS_RESUBMISSION_LABEL = "Is this application a resubmission?";
    static APPLICATION_TYPE_LABEL = "Application type";
    static ZONE_LABEL = "New property zone";
    static AMENDMENT_SCHEME_NUMBER_FORM_CONTROL_NAME = "amendmentSchemeNumber";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPES_FORM_CONTROL_NAME = "applicationTypes";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "type";
    static ZONES_FORM_CONTROL_NAME = "zones";
    static ZONE_FORM_CONTROL_NAME = "zone";
    static PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME = "previousReferenceNumber";
    static IS_RESUBMISSION_FORM_CONTROL_NAME = "isResubmission";
    static ADD_ZONE_LABEL = "Add zone";
    static DUPLICATE_APPLICATION_TYPE_WARNING_MESSAGE = "This application type has already been added.";
    static DUPLICATE_ZONE_WARNING_MESSAGE = "This zone has already been added.";
    static REFERENCE_NUMBER_LABEL = "Reference number";
    static REFERENCE_NUMBER_CONTROL_NAME = "referenceNumber";
    static REZONING_APPLICATION_CONFIRMATION_CONTROL_NAME = "rezoneConfirmation";
    static REZONING_APPLICATION_CONFIRMATION_LABEL = "Is the application a rezoning application?";
    static REZONING_KEYWORD_REZONING = "rezoning";
    static REZONING_KEYWORD_REZONE = "rezone";
    static UNLIMITED_APPLICATION_TYPE_LIMIT = -1;
    static APPLICATION_TYPE_LIMIT_REACHED_WARNING_MESSAGE = "Application type limit reached. You cannot add more application types.";
    static VALIDATION_MESSAGES = {
        amendmentSchemeNumber: {
            required: `Amendment scheme number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
